import type { ReactElement } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from 'src/components/ui/dialog';
import { Button } from 'src/components/ui/button';

export interface ManageAccountsSyncSuccessDialogProps {
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
}

export function ManageAccountsSyncSuccessDialog({ open, onOpenChange }: ManageAccountsSyncSuccessDialogProps): ReactElement {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="sm:max-w-md bg-white">
        <DialogHeader>
          <DialogTitle className="sr-only">
            Sync started
          </DialogTitle>
          <DialogDescription className="text-base text-gray-900">
            Loading Accounts and Campaigns, this may take a few minutes. Feel free to navigate away from this page.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="black"
            onClick={(e) => {
              e.stopPropagation();
              onOpenChange(false);
            }}
          >
            OK
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
